<template>
  <div v-if="current" class="app-message-box-mask" @pointerdown.self.prevent>
    <section ref="dialog" class="app-message-box" role="dialog" aria-modal="true" aria-labelledby="message-box-title" aria-describedby="message-box-description" tabindex="-1" @keydown.esc.stop.prevent @keydown.tab="trapFocus">
      <header class="app-message-box-header">
        <h2 id="message-box-title">{{ current.title }}</h2>
        <button type="button" class="app-message-box-close" aria-label="关闭弹窗" @click="finish(false)">×</button>
      </header>
      <form @submit.prevent="finish(true)">
        <div class="app-message-box-body">
          <span class="app-message-box-icon" aria-hidden="true">!</span>
          <div class="app-message-box-content">
            <p id="message-box-description">{{ current.message }}</p>
            <input v-if="current.kind === 'prompt'" ref="input" v-model="current.value" class="field full app-message-box-input" type="text" :placeholder="current.placeholder" aria-labelledby="message-box-description">
          </div>
        </div>
        <footer class="app-message-box-footer">
          <button ref="cancel" type="button" class="btn" @click="finish(false)">{{ current.cancelText }}</button>
          <button type="submit" class="btn" :class="current.danger ? 'app-message-box-danger' : 'primary'">{{ current.confirmText }}</button>
        </footer>
      </form>
    </section>
  </div>
</template>

<script>
import messageBox from '../services/messageBox'

export default {
  name: 'MessageBox',
  computed: { current () { return messageBox.state.current } },
  watch: {
    current (value) {
      if (value) this.$nextTick(() => {
        const target = this.$refs.input || this.$refs.cancel || this.$refs.dialog
        if (target) { target.focus({ preventScroll: true }); if (this.$refs.input) this.$refs.input.select() }
      })
    }
  },
  methods: {
    finish (confirmed) { messageBox.finish(confirmed) },
    trapFocus (event) {
      const nodes = Array.from(this.$refs.dialog.querySelectorAll('button:not([disabled]), input:not([disabled])'))
      if (!nodes.length) { event.preventDefault(); return }
      const index = nodes.indexOf(document.activeElement)
      if (event.shiftKey && index <= 0) { event.preventDefault(); nodes[nodes.length - 1].focus() }
      else if (!event.shiftKey && (index < 0 || index === nodes.length - 1)) { event.preventDefault(); nodes[0].focus() }
    }
  }
}
</script>
